export const ACCOUNT_STAFF_OPTIONS = [
  {
    uuid: 'all',
    name: 'All Staff',
  },
  {
    uuid: 'active',
    name: 'Active Staff',
  },
  {
    uuid: 'unconfirmed',
    name: 'Inactive Staff',
  },
]
